import React from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';

import { useMenuStyles } from './style';

type MenuProps = {
    children: React.ReactNode,
};

library.add(fas, far);

function Menu(props: MenuProps): React.ReactElement {
    const {
        children,
    } = props;
    const classes = useMenuStyles();

    return (
        <div className={classes.menu}>
            {children}
        </div>
    );
}

export { Menu };
